// extracted by mini-css-extract-plugin
export default {"TextWithHeader":"ColumnTextWithHeader_TextWithHeader__P6V1A","textWrapperContentClass":"ColumnTextWithHeader_textWrapperContentClass__2iA7N"};